import axios from "axios";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_BASE_URL || "";
// Main Axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});
// Separate refresh instance (no interceptors to avoid loops)
const refreshAxios = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});
// Attach token to every request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
let isRefreshing = false;
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "Unauthorized";
    if (status === 401 && !isRefreshing) {
      isRefreshing = true;
      toast.error(message);
      try {
        const token = localStorage.getItem("token") || "";
        const refreshResponse = await refreshAxios.post(
          "/user/refresh",
          {}, // empty body if API expects
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const newToken = refreshResponse?.data?.data?.access_token;
        if (newToken) {
          localStorage.setItem("token", newToken);
          // Retry original request with new token
          error.config.headers.Authorization = `Bearer ${newToken}`;
          isRefreshing = false;
          return axiosInstance(error.config);
        } else {
          // No token received - force logout
          localStorage.clear();
          window.location.href = "/";
          return Promise.reject(error);
        }
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        isRefreshing = false;
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
